import { AgencyService } from './common-theme/api/agency.service';
import { Component, OnDestroy, Inject, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Subscription } from 'rxjs/Subscription';
import { MenuLink } from './common-theme/base-components/shared/menu/menu-link.model';
import { ScrollToService, ScrollToConfigOptions } from '@nicky-lenaers/ngx-scroll-to';
import { DOCUMENT } from '@angular/platform-browser';
import { FbqService, GtagService } from './common-theme';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})

export class AppComponent implements OnInit, OnDestroy {
  @ViewChild('scrollToTop') scrollToTop: ElementRef;
  subscription: Subscription;
  pageHeight: number;
  public currentRoute: string = '/';
  public links: MenuLink[] = [
    new MenuLink('/', 'home', []),
    new MenuLink('/romanescu-lifestyle/concept', 'downtown', []),
    new MenuLink('/apartamente', 'apartments', []),
    new MenuLink('/localizare', 'localisation', []),
    new MenuLink('/parteneri', 'partners', []),
    new MenuLink('/contacteaza-ne', 'contact', [])
  ];
  private noScrollTopRoutes: string[] = [
    '/romanescu-lifestyle/concept',
    '/romanescu-lifestyle/detalii-proiect',
    '/romanescu-lifestyle/facilitati',
    '/romanescu-lifestyle/galerie'
  ];

  constructor(
    public agencyService: AgencyService,
    public fbqService: FbqService,
    public gtagService: GtagService,
    private _scrollToService: ScrollToService,
    router: Router,
    @Inject('WINDOW') private window: any,
    @Inject('SCREEN') private screen: any,
    @Inject(DOCUMENT) private document: any
  ) {

    if (router) {
      router.events.subscribe(s => {
        if (s instanceof NavigationEnd) {
          const tree = router.parseUrl(router.url);
          this.currentRoute = router.url;

          if (!tree.fragment && this.window)
            if (!this.noScrollTopRoutes.includes(this.currentRoute))
              this.window.scrollTo(0, 0);
        }
      });
    }
  }

  ngOnInit(): void {
    if (this.screen)
      this.pageHeight = this.screen.height - 300;
  }

  public triggerScrollTo(target: string): void {
    const config: ScrollToConfigOptions = {
      target: target
    };

    this._scrollToService.scrollTo(config);
  }

  public onScroll(): void {
    if (Math.max(this.document.body.scrollTop, this.document.documentElement.scrollTop) > 24)
      this.scrollToTop.nativeElement.classList.add('active');
    else
      this.scrollToTop.nativeElement.classList.remove('active');
  }

  ngOnDestroy(): void {
    if (this.subscription)
      this.subscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts